import React from 'react'
import './App.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../node_modules/bootstrap/dist/js/bootstrap.bundle'
import { Switch, Route, Redirect } from 'react-router-dom'
import Home from './pages/Home'
import Contact from './pages/Contact'
import Services from './pages/Courses/Schooling'
import About from './pages/About'
import Navbar from './component/Navbar'
import MarketPlace from './pages/MarketPlace'
import Reviews from './pages/Reviews'
import Login from './pages/LoginPage'
import SignUp from './pages/SignUpPage'
import { AuthProvider } from './auth/auth'
import Courses from './pages/Courses';
import CourseSchool from './pages/CourseSchool';
import Footer from './component/Footer'
import Professional_Courses from './pages/Courses/Professional_Courses'
import UserProfile from './pages/UserProfile';
import ReactNotificationComponent from 'react-notifications-component'
import "react-notifications-component/dist/theme.css";
import Projects from './pages/Projects';
function App() {

  return (
    <AuthProvider> <Navbar />
      <ReactNotificationComponent />
      <Switch>
        <Route path='/services' component={Services} />
        <Route path='/professional' component={Professional_Courses} />
        <Route path='/contact' component={Contact} />
        <Route path='/about' component={About} />
        <Route exact path='/' component={Home} />
        <Route path='/market-place' component={MarketPlace} />
        <Route path='/reviews' component={Reviews} />
        <Route path='/login' component={Login} />
        <Route path='/sign-up' component={SignUp} />
        <Route path='/profile' component={UserProfile} />
        <Route path={'/courses/:title'} component={Courses} />
        <Route path={'/school-courses/:title'} component={CourseSchool} />
        <Route to='/projects' component={Projects} />
        <Redirect to='/' />
      </Switch>
      <Footer />
    </AuthProvider>
  );
}

export default App;
